import React, { useState } from 'react';
import './DateRangeSelector.css';

const DateRangeSelector = ({ dateRange, onDateRangeChange, customDateRange, onCustomDateRangeChange }) => {
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  const quickRanges = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 Days', value: 'last7Days' },
    { label: 'Last 30 Days', value: 'last30Days' },
    { label: 'This Month', value: 'thisMonth' },
    { label: 'Custom Range', value: 'custom' }
  ];

  const handleRangeClick = (value) => {
    if (value === 'custom') {
      setShowCustomPicker(true);
    } else {
      onDateRangeChange(value);
      setShowCustomPicker(false);
    }
  };

  const handleCustomDateSubmit = () => {
    if (customDateRange.from && customDateRange.to) {
      onDateRangeChange('custom');
      setShowCustomPicker(false);
    }
  };

  return (
    <div className="date-range-selector">
      <div className="quick-range-buttons">
        {quickRanges.map(range => (
          <button
            key={range.value}
            className={`range-btn ${dateRange === range.value ? 'active' : ''}`}
            onClick={() => handleRangeClick(range.value)}
          >
            {range.label}
          </button>
        ))}
      </div>

      {showCustomPicker && (
        <div className="custom-date-picker">
          <div className="custom-date-inputs">
            <div className="date-input-group">
              <label>From</label>
              <input
                type="date"
                value={customDateRange.from}
                onChange={(e) => onCustomDateRangeChange({ ...customDateRange, from: e.target.value })}
              />
            </div>
            <div className="date-input-group">
              <label>To</label>
              <input
                type="date"
                value={customDateRange.to}
                onChange={(e) => onCustomDateRangeChange({ ...customDateRange, to: e.target.value })}
              />
            </div>
            <button className="apply-date-btn" onClick={handleCustomDateSubmit}>
              Apply
            </button>
            <button className="cancel-date-btn" onClick={() => setShowCustomPicker(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {dateRange === 'custom' && customDateRange.from && customDateRange.to && (
        <div className="selected-range">
          {new Date(customDateRange.from).toLocaleDateString()} - {new Date(customDateRange.to).toLocaleDateString()}
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;

